export default function findAncestor(el: Node | null, matchingFunc: (el: Node) => boolean): Node | null {
  let scanner: Node | null = el;
  while (scanner && !matchingFunc(scanner)) {
    scanner = scanner.parentNode;
  }
  return scanner;
}
